import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import fraImage from './assets/images/Our_Story.webp'; // Replace with your image if needed
import logo from './assets/images/Logo.avif'; // Replace with your logo if needed

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/login`,
                {
                    email,
                    password,
                }
            );
            console.log(response)

            if (response.data.data?.token) {
                const token = response.data.data.token;
                const user = response.data.data.user; // contains role and accessPages

                localStorage.setItem('authToken', token);
                localStorage.setItem('role', user.role);
                localStorage.setItem('accessPages', JSON.stringify(user.AccessPages || []));

                const { exp } = JSON.parse(atob(token.split('.')[1]));
                localStorage.setItem('tokenExpiry', exp * 1000);

                navigate('/Dashboard');
            } else {
                setErrorMessage('Login failed, please check your credentials.');
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'An error occurred. Please try again.');
        }
    };

    return (
        <div className="login-container d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="row w-100">
                {/* Image Section */}
                <div className="col-xl-6 d-none d-xl-flex justify-content-center align-items-center">
                    <img src={fraImage} alt="Camera Illustration" className="img-fluid" style={{ maxHeight: '600px', width: '95%' }} />
                </div>

                {/* Login Form Section */}
                <div className="col-xl-6 d-flex justify-content-center align-items-center">
                    <div className="card p-4 shadow-lg rounded-lg" style={{ width: '400px' }}>
                        <img src={logo} alt="Logo" className="img-fluid mb-4" style={{ maxHeight: '200px' }} />

                        <form onSubmit={handleLogin}>
                            {/* Email Input */}
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Password Input */}
                            <div className="mb-3 position-relative">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <span
                                    className="position-absolute end-0 me-3 text-muted"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        top: "68%",
                                        transform: "translateY(-50%)", // Centers icon properly
                                        right: "10px", // Moves inside input
                                        cursor: "pointer"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            {/* Error Message */}
                            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                            {/* Submit Button */}
                            <button type="submit" className="btn btn-primary w-100 mt-3">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
